export default {
  MARKET_REPRESENTATIVE: 'MARKET_REPRESENTATIVE',
  ELERING_ADMINISTRATOR: 'ELERING_ADMINISTRATOR',
  CONSUMER: 'CONSUMER',
  NOT_REGISTERED_CONSUMER: 'NOT_REGISTERED_CONSUMER',
};
